import CircularProgress from '@mui/material/CircularProgress';
import { useEffect } from 'react';
import styled from 'styled-components';
import COLORS from '../../colors';
import { useModal } from '../../context/ModalContext';

interface LoadingProps {
  loadingError: boolean;
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;

const StyledHeading = styled.h6`
  font-size: 19.2px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.384px;
  color: ${COLORS.NEUTRAL_200};
  margin: 24px 0;
`;

const Loading = ({ loadingError }: LoadingProps) => {
  const { closeModal, openModal } = useModal();

  useEffect(() => {
    if (loadingError) {
      openModal('ActionModal', {
        title: 'Error Loading Content',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        cancelButtonText: 'Return',
        okButtonText: 'Try Again',
        modalCallback
      });
    }
  }, [loadingError]);

  const modalCallback = () => {
    closeModal();
    window.location.href = '/';
  };

  return (
    <StyledContainer>
      <CircularProgress />
      <StyledHeading>Loading...</StyledHeading>
    </StyledContainer>
  );
};

export default Loading;
